import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-rotatedmarker";

const RotatedMarker = ({
  position,
  icon,
  rotationAngle = 0,
  rotationOrigin = "center",
  draggable = false,
  opacity = 1,
  zIndexOffset = 0,
  onClick,
  onMouseOver,
  onMouseOut,
}) => {
  const map = useMap();
  const markerRef = useRef(null);

  useEffect(() => {
    if (!map) return;

    const marker = L.marker(position, {
      icon,
      rotationAngle,
      rotationOrigin,
      draggable,
      opacity,
      zIndexOffset,
    });

    // Bind events
    if (onClick) marker.on("click", onClick);
    if (onMouseOver) marker.on("mouseover", onMouseOver);
    if (onMouseOut) marker.on("mouseout", onMouseOut);

    marker.addTo(map);
    markerRef.current = marker;

    return () => {
      marker.removeFrom(map);
    };
  }, [map]);

  useEffect(() => {
    const marker = markerRef.current;
    if (!marker) return;

    marker.setLatLng(position);
    marker.setRotationAngle(rotationAngle);
    marker.setRotationOrigin(rotationOrigin);
    marker.setOpacity(opacity);
    marker.setZIndexOffset(zIndexOffset);

    if (icon) marker.setIcon(icon);
    if (draggable) {
      marker.dragging.enable();
    } else {
      marker.dragging.disable();
    }
  }, [position, icon, rotationAngle, rotationOrigin, draggable, opacity, zIndexOffset]);

  return null;
};

export default RotatedMarker;

